import { render, staticRenderFns } from "./ChooseServiceMulti.vue?vue&type=template&id=bc070a52&scoped=true"
import script from "./ChooseServiceMulti.vue?vue&type=script&lang=js"
export * from "./ChooseServiceMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc070a52",
  null
  
)

export default component.exports